import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import { FormCustom, Select } from '../../Components/Form/Form';
import ReactPlaceholder from 'react-placeholder'
import Button from 'react-bootstrap/esm/Button';
import { useSelector } from 'react-redux';

const PeriodBono = _ => {
    const [ready, setReady] = useState(false)
    const [isProcessing, setIsProccesing] = useState(false)
    const [periodSelected, setPeriodSelected] = useState('')
    const [rows, setRows] = useState([])
    const [period, setPeriod] = useState([])
    const typeUser = useSelector(store => store.session.type)
    const [reporte, setReport] = useState({})

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
            setReady(true)
        })
    }, [])

    const handleSubmit = _ => {
        setIsProccesing(true)
        Controllers.customers.get_period_bono({
            p_id_period: periodSelected,
            p_type_user: typeUser
        }).then(res => {
            setRows(res.data.data)
            setReport({
                excel: res.data.excel.file,
                filename: res.data.excel.filename,
            })
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_customers', text: 'ID', align: 'center' },
                { name: 'full_name', text: 'Nombres' },
                { name: 'name_plan', text: 'Rango' },
                { name: 'benefits_plan', text: 'Bono Viaje', align: 'center' },
                /* { name: 'auto_bono', text: 'Bono Auto', align: 'center' }, */
                { name: 'type_fee', text: 'Régimen', align: 'center' },
                { name: 'subtotal_earnings', text: 'Bono Auto', align: 'center', render: r => r.subtotal_earnings ? '$ ' + r.subtotal_earnings : '' },
                { name: 'isr', text: 'ISR', align: 'center', render: r => r.isr ? '$ ' + r.isr : '' },
                { name: 'iva', text: 'IVA', align: 'center', render: r => r.iva ? '$ ' + r.iva : '' },
                { name: 'ret_iva', text: 'RET IVA', align: 'center', render: r => r.ret_iva ? '$ ' + r.ret_iva : '' },
                { name: 'resico', text: 'RESICO', align: 'center', render: r => r.resico ? '$ ' + r.resico : '' },
                { name: 'total', text: 'Total', align: 'center', render: r => r.total ? '$ ' + r.total : '' },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <ReactPlaceholder rows={10} showLoadingAnimation ready={ready}>
            <Card>
                <Card.Header className="justify-content-between">
                    <span>Bonos por periodo</span>
                </Card.Header>
                <Card.Body>
                    <FormCustom viewSubmit={false}>
                        <Select
                            text="Periódo"
                            classNameParent="col-12 mb-2"
                            options={period.map(p => {
                                return {
                                    label: p.name_period,
                                    value: p.id_period
                                }
                            })}
                            onChange={e => setPeriodSelected(e.value)}
                            append={[
                                <Button onClick={handleSubmit}>
                                    <i className="fa fa-search"></i>
                                </Button>
                            ]}
                        />
                    </FormCustom>
                    {reporte?.filename ? <div className='mb-4'>
                        <a href={reporte?.excel} download={reporte?.filename}>
                            <Button size="sm" variant="success">
                                <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                            </Button>
                        </a>
                    </div> : ''}
                    {dtRows}
                </Card.Body>
            </Card>
            {/* isProcessing ? '' : <div className="d-flex justify-content-center mt-4">
                <div className="alert alert-success text-center">
                    <h5>Total de Comisiones</h5>
                    {moneyList()}
                </div>
            </div> */}
        </ReactPlaceholder>
    </>
}

export default PeriodBono